export default {
      id: "ic-vote-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-vote-usage",
      toString: function () {
        return this.url;
      }
    }